export default __webpack_public_path__ + "static/media/notification-buckets-1.b717d7d4.png";